/* NSH Quiz tracking layer v5.2 (2026-10-21). All locales. ASCII only except the v5.1 note line.
   v5.2 (2026-10-21, theme v13.14 - first screen = first question, assets/nsh-quiz-seq.js):
   - every record carries extra.intro = 'q-first' (next to consent / mode / test / state_key).
   - sequence mode = window.NSH_Q1 present (set inline by the template before this file). Then quiz_start is NOT sent when
     #quiz shows; seq calls window.NSH_trackQ1Start() on the first concern chip tap -> quiz_start (once; reset when the
     first screen comes back through restart, not when the reader steps back to it). That tap counts as screen 1.
   - quiz_q: the screen number -> question through window.NSH_seqAt(n) ({id, qi, pick}) in the new display order;
     q_id / prev_q stay question ids (concern, concern2, detail_<code>, wash_temp ... trouble, age), picks keep their codes.
     Without seq the v4.2 path (NSH_dispToIdx) is unchanged.
   v5.1 (2026-10-21): EU·UK 미동의 시 식별값 제거 켬 -- OPTIN_STRIP_IDS = true (mirror in assets/nsh-consent.js v3.1).
   v5.0 summary (founder decision 2026-10-21, replaces item 8 below):
   - Every record is sent to the Apps Script sheet at once, whatever the consent state or region. No holding in memory,
     no dropping, no 'bare' records. sid / entry / referrer / ref / cta / by / utm_* / mobile / uid as before.
   - nshAttr (sid + attribution) is kept in sessionStorage always, so sid stays the same for the whole tab session.
   - Flat fields unchanged (GAS columns). New object `extra` on every record:
       extra.consent 'all' | 'essential' | 'none' (none = no explicit choice yet, also the automatic notice-mode default)
       extra.mode    'notice' | 'optin' (window.NSH_CONSENT_STATE.mode from snippets/nsh-consent)
       extra.test    1 when the session was opened with ?test=1 (kept in nshAttr.test)
       extra.state_key on quiz_complete and waitlist_join (same value as the flat quiz_complete state_key).
   - consent_choice {value:'all'|'essential'} comes from assets/nsh-consent.js through window.NSH_TRACK_LOG.
   - OPTIN_STRIP_IDS (below): legal review switch. v5.0 false; v5.1 true.
   - dataLayer never gets `email` (unchanged).
   ---- earlier notes ----
   v4 (2026-09-13).
   1) Attribution per session (sessionStorage nshAttr): entry, ref, referrer host, utm_*, sid.
   2) logEvent is replaced: same outputs (dataLayer + GAS beacon + console) but every record
      carries the attribution fields, and `email` never enters dataLayer (GAS beacon only).
   3) Funnel events the engine never had: quiz_page_view, quiz_start, quiz_q (per question), quiz_restart.
   4) once-per-page dedup for quiz_complete / v9_view / v9_gate_reach (the engine can call finish twice).
   5) v9_gate_reach by scroll, not IntersectionObserver (IO callbacks do not run in some embedded
      browsers, which loses the whole metric). If v9.js also reports it, dedup keeps one.
   6) v4.1 (2026-10-01) note links: ?ref=note-<handle>&cta=a|b|c (the CTA slots on article pages).
      entry becomes 'note', the tab is re-attributed when a note link brings a different note or slot
      (same tab, earlier quiz visit), and every record carries cta next to ref.
   7) v4.2 (2026-10-04) answers: every quiz_q also carries the answer of the screen just left
      (prev_q, pick), and quiz_complete carries the whole answer set as fixed English codes
      (ans), the question version (qv), state/barrier/load, and a replay link. Multi-select
      questions are arrays in tap order of the screen (forehead and nose are kept apart even
      though the result logic treats them as one). Codes never change when copy changes.
   8) v5 (2026-10-02) consent: records leave the page (GAS beacon) only after the visitor allows analytics
      in the cookie dialog (snippets/nsh-consent, window.NSH_CONSENT_STATE, event 'nsh:consent').
      Until they choose, records wait in memory; allowed -> sent in order; refused -> dropped, except
      waitlist_join (the visitor typed the email to get the guide), which goes without the attribution
      fields. nshAttr is written to sessionStorage only after consent. dataLayer pushes stay as they were:
      GTM itself loads only after consent. A page without the dialog keeps the old behaviour.
   9) v4.4 (2026-10-10) sharer code: a landing URL with by=<code> (the sharer's nshUid, 8 chars base36) keeps it in the session
      attribution (attr.by) and every record carries `by`. quiz_complete and waitlist_join carry the visitor's own code as `uid`
      (localStorage nshUid, made by nsh-quiz-v13q.js), so the sheet can link uid and email without the email entering a URL.
      by and uid are dropped with the other attribution fields when analytics is refused.
  10) v13.12 (2026-10-17) the reader's own result link is ?state=&a= without ref / by (nsh-quiz-return.js), so state+a alone
      is a return, not a share: entry 'share' needs ref=share, or a and by= without ref=cal (same test as the v13 friend view).
   Event names already wired in GTM (regex trigger): quiz_product_click quiz_complete waitlist_join
   share_card_save share_click note_click quiz_visit_from_share share_landing_start.
   New names (extend the GTM trigger regex): quiz_page_view quiz_start quiz_q quiz_restart
   v9_view v9_gate_reach v9_calendar. */
(function(){
  if(window.__NSH_TRACK)return; window.__NSH_TRACK=5.2;
  /* LEGAL REVIEW SWITCH (v5.1: true). false = send everything. true = for records whose extra.mode is 'optin' and
     extra.consent is not 'all', remove sid, entry, referrer, ref, cta, by, uid, mobile and utm_* before the record leaves
     the page (like v4's refused-consent records). Mirror in assets/nsh-consent.js (OPTIN_STRIP_IDS). */
  var OPTIN_STRIP_IDS = true;
  var W=window,D=document;
  function sp(){try{return new URL(location.href).searchParams}catch(e){return null}}
  function host(u){try{return new URL(u).hostname.replace(/^www\./,'')}catch(e){return ''}}
  function rnd(){return Math.random().toString(36).slice(2,10)}
  var SS=null;try{SS=W.sessionStorage}catch(e){}
  function get(k){try{return SS?SS.getItem(k):null}catch(e){return null}}
  function set(k,v){try{if(SS)SS.setItem(k,v)}catch(e){}}
  var DROP={sid:1,entry:1,referrer:1,ref:1,cta:1,by:1,uid:1,mobile:1,utm_source:1,utm_medium:1,utm_campaign:1,utm_content:1,utm_term:1};
  function saveAttr(){set('nshAttr',JSON.stringify(attr))}

  /* --- attribution --- */
  var q=sp(),UTM=['utm_source','utm_medium','utm_campaign','utm_content','utm_term'];
  var utm={};UTM.forEach(function(k){var v=q&&q.get(k);if(v)utm[k]=String(v).slice(0,80)});
  var ref=(q&&q.get('ref'))||'',hasState=!!(q&&q.get('state')),hasA=!!(q&&q.get('a'));
  var cta=String((q&&q.get('cta'))||'').slice(0,8),fromNote=/^note-/.test(ref);
  var by=String((q&&q.get('by'))||'').toLowerCase();if(!/^[0-9a-z]{8}$/.test(by))by='';
  var own=location.hostname.replace(/^www\./,''),refHost=host(D.referrer);
  if(refHost===own)refHost='';
  var entry=(ref==='share'||(hasState&&hasA&&by&&ref!=='cal'))?'share':fromNote?'note':utm.utm_source?'utm':refHost?'referral':hasState?'return':'direct';
  var attr=null;try{attr=JSON.parse(get('nshAttr')||'null')}catch(e){attr=null}
  if(!attr||!attr.sid||utm.utm_source||entry==='share'||(by&&attr.by!==by)||(fromNote&&(attr.ref!==ref||(attr.cta||'')!==cta))){
    var prev=attr||{};
    attr={sid:prev.sid||rnd(),entry:entry,ref:ref,referrer:refHost,landing:location.pathname,t0:new Date().toISOString()};
    if(cta)attr.cta=cta;
    if(by)attr.by=by;
    for(var k in utm)attr[k]=utm[k];
    if(prev.test)attr.test=1;
    saveAttr();
  }
  if(q&&q.get('test')==='1'&&!attr.test){attr.test=1;saveAttr()}
  /* locale from the path, like the template and gate.js. Reading <html lang> at script time is
     unreliable: the locale patches can still be settling, which mislabels /ja as en. */
  var pre=location.pathname.slice(0,4);
  var locale=pre==='/ko/'?'ko':pre==='/ja/'?'ja':'en';
  function common(){
    var o={locale:locale,ver:(locale==='ko'&&W.NSH_V9)?'v9':'v8',sid:attr.sid,entry:attr.entry,referrer:attr.referrer||''};
    if(attr.ref)o.ref=attr.ref;
    if(attr.cta)o.cta=attr.cta;
    if(attr.by)o.by=attr.by;
    UTM.forEach(function(k){if(attr[k])o[k]=attr[k]});
    try{o.mobile=W.matchMedia&&W.matchMedia('(max-width: 768px)').matches?1:0}catch(e){}
    return o;
  }
  W.NSH_attr=function(){return common()};
  function extra(){
    var s=W.NSH_CONSENT_STATE||null,x={};
    x.consent=(s&&s.chosen)?(s.analytics?'all':'essential'):'none';
    x.mode=(s&&(s.mode==='notice'||s.mode==='optin'))?s.mode:(locale==='ko'?'notice':'optin');
    if(attr.test)x.test=1;
    x.intro='q-first';
    return x;
  }

  /* --- logEvent replacement --- */
  var ENDPOINT=null;try{ENDPOINT=(typeof NSH_TRACK_ENDPOINT!=='undefined')?NSH_TRACK_ENDPOINT:null}catch(e){ENDPOINT=null}
  var ONCE={quiz_complete:1,v9_view:1,v9_gate_reach:1,quiz_start:1},fired={};
  var SEQ=!!W.NSH_Q1;
  function post(rec){if(ENDPOINT&&typeof navigator!=='undefined'&&navigator.sendBeacon){try{navigator.sendBeacon(ENDPOINT,new Blob([JSON.stringify(rec)],{type:'text/plain;charset=UTF-8'}))}catch(e){}}}
  function strip(rec){var o={},k;for(k in rec)if(!DROP[k])o[k]=rec[k];return o}
  function beacon(rec){var x=rec.extra||{};post(OPTIN_STRIP_IDS&&x.mode==='optin'&&x.consent!=='all'?strip(rec):rec)}
  function send(name,payload){
    if(ONCE[name]){if(fired[name])return;fired[name]=1}
    var rec={event:name,ts:new Date().toISOString()},p=payload||{},k;
    for(k in p)if(Object.prototype.hasOwnProperty.call(p,k))rec[k]=p[k];
    var c=common();for(k in c)if(rec[k]===undefined)rec[k]=c[k];
    var x=extra(),px=(p.extra&&typeof p.extra==='object')?p.extra:{};for(k in px)if(Object.prototype.hasOwnProperty.call(px,k))x[k]=px[k];
    rec.extra=x;
    var dl={};for(k in rec)if(k!=='email')dl[k]=rec[k];
    W.dataLayer=W.dataLayer||[];W.dataLayer.push(dl);
    beacon(rec);
    try{console.log('[quiz]',dl)}catch(e){}
  }
  W.logEvent=send;

  /* --- answers as codes (v4.2) --- */
  var CODES={
    age:['10s','20s','30s','40s','50plus'], gender:['na','f','m'],
    wash_temp:['hot','lukewarm','cold'], wash_count:['1','2','3plus','varies'],
    afterwash:['tight_all','cheek_tight_tzone_oily','oily_soon','comfortable'],
    toweloff:['sting','tight_no_sting','fine'],
    afternoon:['flaky','tzone_oily_cheek_dry','oily_all','same_as_morning'],
    tight:['often','after_wash_only','rarely'],
    steps:['5plus','3_4','1_2','almost_none'], actives:['3plus','2','1','none_or_unsure'],
    exfoliate:['2plus_week','1_week','biweekly_or_less','none'],
    newprod:['often_sting','sometimes_sensitive','calm'], redness:['several','once_twice','none'],
    bump:['forehead','nose','cheek','chin','none'], mf:['comedo','red_pus','itch_scalp_back','none'],
    trouble:['add_more','cut_back','dermatologist','keep_same']
  };
  var CONCERN={T:'tone',C:'spots',A:'pores',K:'blackheads',B:'wrinkles',G:'trouble',F:'redness',E:'dark_circles','':'none'};   /* v4.3 (2026-10-06): 9 concerns */
  var MASK={bump:[[1,'forehead_or_nose'],[2,'cheek'],[4,'chin']],mf:[[1,'comedo'],[2,'red_pus'],[4,'itch_scalp_back']]};
  var TAPS={};   /* multi-select: option indices as shown on the screen, kept from taps */
  function qAt(i){try{return (typeof Q!=='undefined'&&Q[i])||null}catch(e){return null}}
  function ansAt(i){try{var a=answers[i];return (a===undefined||a===null)?null:a}catch(e){return null}}
  function codeOf(i){
    var q=qAt(i);if(!q||!q.id)return null;var id=q.id,a=ansAt(i);
    if(id==='concern')return concernCodes();
    if(q.multi){
      if(TAPS[id]&&TAPS[id].length)return TAPS[id].map(function(k){return (CODES[id]&&CODES[id][k])||String(k)});
      if(a===null)return null;if(a===0)return ['none'];
      return (MASK[id]||[]).filter(function(m){return a&m[0]}).map(function(m){return m[1]});
    }
    if(a===null)return null;
    return (CODES[id]&&CODES[id][a]!==undefined)?CODES[id][a]:String(a);
  }
  function concernCodes(){
    var out=[];try{var c1=String((acc&&acc.concern)||'').charAt(0);out.push(CONCERN[c1]||'none');
      var i2=W.__nshC2;if(i2!==null&&i2!==undefined){var lq=Q[Q.length-1],o=lq&&lq.o&&lq.o[i2];if(o&&o.concern&&o.concern!==c1)out.push(CONCERN[o.concern]||o.concern)}}catch(e){}
    return out;
  }
  function allAnswers(){var o={};try{for(var i=0;i<Q.length;i++){var q=Q[i];if(q&&q.id){var v=codeOf(i);if(v!==null)o[q.id]=v}}}catch(e){}return o}
  function curQi(){try{return (typeof idx!=='undefined')?idx:-1}catch(e){return -1}}
  D.addEventListener('click',function(ev){
    var b=ev.target&&ev.target.closest&&ev.target.closest('button.opt');if(!b)return;
    setTimeout(function(){
      var q=qAt(curQi());if(!q||!q.multi||!q.id)return;
      var opts=Array.prototype.filter.call(D.querySelectorAll('button.opt'),function(x){return x.offsetParent});
      var sel=[];opts.forEach(function(x,k){if(x.classList.contains('sel'))sel.push(k)});
      TAPS[q.id]=sel;
    },0);
  },true);
  function myUid(){var v='';try{v=(typeof W.NSH_uid==='function'&&W.NSH_uid())||localStorage.getItem('nshUid')||''}catch(e){v=''}return /^[0-9a-z]{8}$/.test(v)?v:''}
  function stateKey(){try{var r=classify();return r.P+(r.care?'T':'F')}catch(e){return ''}}
  function enrich(name,p){
    if(name!=='quiz_complete'&&name!=='waitlist_join')return p;
    var o={},k;for(k in p)if(Object.prototype.hasOwnProperty.call(p,k))o[k]=p[k];
    var me=myUid();if(me&&o.uid===undefined)o.uid=me;
    /* v5: waitlist_join gets the same state_key as quiz_complete, in extra only (flat columns unchanged) */
    var sk=stateKey();if(sk){o.extra={state_key:sk}}
    if(name==='waitlist_join')return o;
    try{
      o.qv=W.__NSH_V13Q?13:(W.__NSH_V11_Q?11:10);o.ans=allAnswers();if(W.__nshD)o.detail=W.__nshD;
      var r=classify(),key=r.P+(r.care?'T':'F');o.state_key=key;o.barrier=r.care?'care':'stable';o.load_code={'과소':'under','적정':'ok','과부하':'over'}[r.load]||r.load;
      var slug=(typeof STATE_SLUGS!=='undefined'&&STATE_SLUGS[key])||'';
      var a=answers.slice(0,Q.length).join(''),c2='';
      try{var i2=W.__nshC2;if(i2!==null&&i2!==undefined){var o2=Q[Q.length-1].o[i2];c2=(o2&&o2.concern)||''}}catch(e){}
      var dd='';try{if(W.__nshD){dd=Object.keys(W.__nshD).map(function(k){return k+String(W.__nshD[k]||0)}).join('')}}catch(e){}
      o.replay=location.origin+location.pathname+'?state='+slug+'&a='+a+(c2?'&c2='+c2:'')+(dd?'&d='+dd:'');
    }catch(e){}
    return o;
  }
  var send0=send;send=function(name,payload){return send0(name,enrich(name,payload||{}))};W.logEvent=send;
  /* consent_choice from assets/nsh-consent.js (explicit choices only) */
  W.NSH_TRACK_LOG=function(name,payload){send(name,payload||{})};

  /* --- page view with attribution (GA4 page_view carries no custom params) --- */
  send('quiz_page_view',{has_state:hasState?1:0,path:location.pathname});

  /* --- funnel: DOM-observed so patch order does not matter --- */
  var lastQ=0;
  function onIntro(){if(W.__nshSeqBack){W.__nshSeqBack=0;return}fired.quiz_start=0;lastQ=0}
  function onQuiz(){if(!SEQ)send('quiz_start',{})}
  /* v5.2: the first concern chip (seq) */
  W.NSH_trackQ1Start=function(){send('quiz_start',{});lastQ=1};
  function seqAt(n){try{return (SEQ&&typeof W.NSH_seqAt==='function')?W.NSH_seqAt(n):null}catch(e){return null}}
  function onCount(){
    var el=D.getElementById('count');if(!el)return;
    var qz=D.getElementById('quiz');if(SEQ&&qz&&qz.classList.contains('hidden'))return;   /* v5.2: a count repaint behind the first screen / result is not a screen */
    var m=/(\d+)\s*\/\s*(\d+)/.exec(el.textContent||'');if(!m)return;
    var n=parseInt(m[1],10),total=parseInt(m[2],10);if(!n||n===lastQ)return;
    var dir=n>lastQ?'next':'back',prev=lastQ;lastQ=n;
    var qid='',si=seqAt(n);try{if(si)qid=si.id||'';else{var qi=(typeof W.NSH_dispToIdx==='function')?W.NSH_dispToIdx(n):n-1;qid=(typeof Q!=='undefined'&&Q[qi]&&Q[qi].id)||''}}catch(e){}
    var pl={q_index:n,q_id:qid,total:total,dir:dir};
    if(dir==='next'&&prev>0){try{var ps=seqAt(prev),pi,pq,pid;
      if(ps){pid=ps.id;pi=ps.qi}else{pi=(typeof W.NSH_dispToIdx==='function')?W.NSH_dispToIdx(prev):prev-1;pq=qAt(pi);pid=pq&&pq.id}
      if(pid){pl.prev_q=pid;pl.pick=(pi>=0)?codeOf(pi):(ps?ps.pick:null);if(pid==='age'){var gi=-1;for(var j=0;j<Q.length;j++)if(Q[j]&&Q[j].id==='gender'){gi=j;break}if(gi>=0)pl.pick_gender=codeOf(gi)}}}catch(e){}}
    send('quiz_q',pl);
  }
  /* v11 (2026-09-28): 숨은 문항(성별)이 생겨 화면 번호와 문항 인덱스가 어긋난다. v11 이 준 표(NSH_dispToIdx)로 찾는다. */
  /* gate reach: the email gate is 20% into view. Scroll-based; IO is unreliable in embedded browsers. */
  function gateCheck(){
    if(fired.v9_gate_reach)return;
    var g=D.getElementById('v9gate');
    if(!g||g.className.indexOf('hidden')>=0)return;
    var r=g.getBoundingClientRect(),vh=W.innerHeight||D.documentElement.clientHeight;
    if(!r.height)return;
    var vis=Math.min(r.bottom,vh)-Math.max(r.top,0);
    if(vis/r.height>=0.2){var st='';try{st=(W.__wl&&W.__wl.slug)||''}catch(e){}send('v9_gate_reach',{state:st})}
  }
  function watch(){
    var quiz=D.getElementById('quiz'),intro=D.getElementById('intro'),count=D.getElementById('count');
    if('MutationObserver' in W){
      if(quiz){new MutationObserver(function(){if(!quiz.classList.contains('hidden'))onQuiz()}).observe(quiz,{attributes:true,attributeFilter:['class']});
        if(!quiz.classList.contains('hidden'))onQuiz()}
      if(intro){new MutationObserver(function(){if(!intro.classList.contains('hidden'))onIntro()}).observe(intro,{attributes:true,attributeFilter:['class']})}
      if(count){new MutationObserver(onCount).observe(count,{childList:true,characterData:true,subtree:true})}
    }
    try{var r0=W.restart;if(typeof r0==='function'){W.restart=function(){send('quiz_restart',{});return r0.apply(this,arguments)}}}catch(e){}
    W.addEventListener('scroll',gateCheck,{passive:true});
    W.addEventListener('resize',gateCheck,{passive:true});
    /* poll too: some embedded browsers fire neither scroll nor IntersectionObserver,
       and losing the whole gate metric there is worse than one rect read per second. */
    var t0=Date.now(),iv=setInterval(function(){
      if(fired.v9_gate_reach||Date.now()-t0>300000){clearInterval(iv);return}
      gateCheck();
    },1000);
  }
  if(D.readyState==='loading')D.addEventListener('DOMContentLoaded',watch);else watch();
})();